<template>
  <div class="page_paymentList">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="topForm">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="项目" size="small">
              <el-select v-model="listQuery.Projectid" placeholder="" value-key="Projectid" size="small" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" size="small">
              <el-input v-model="listQuery.InsuredCardId" size="small" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="隶属公司" size="small">
              <el-input v-model="listQuery.ContractParty" size="small" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="归属月" size="small">
              <el-date-picker v-model="listQuery.StrMonth" type="month" placeholder="选择月" value-format="yyyy-MM" :clearable="false">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>商保管理</el-breadcrumb-item>
          <el-breadcrumb-item>缴费名单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="background-color: #fff;">
        <tabs :name="name"></tabs>
      </div>
      <div class="ftabs">
        <div style="margin-bottom: 10px;" class="flex">
          <el-button type="primary" size="small" v-preventReClick @click="expList()">&nbsp;导出列表</el-button>
        </div>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" :element-loading-text="progress>=0 && progress!='' ? '确认名单中' + progress + '%' : ''" style="width:100%">
          <el-table-column label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" :show-overflow-tooltip="true" align="center" width="100">
          </el-table-column>
          <el-table-column label="子项目" :show-overflow-tooltip="true" align="center" width="100">
            <template slot-scope={row}>{{ '' }}</template>
          </el-table-column>
          <el-table-column prop="InsuredCardId" label="证件号码" :show-overflow-tooltip="true" align="center" width="150">
          </el-table-column>
          <el-table-column prop="InsuredName" label="员工姓名" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="age" label="年龄" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ getAge(row.InsuredCardId) }}</template>
          </el-table-column>
          <el-table-column prop="InsuredPhone" label="手机号码" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <el-table-column prop="InsuranceName" label="险种" :show-overflow-tooltip="true" align="center" width="130">
          </el-table-column>
          <el-table-column prop="CreateTime" label="申请日期" :show-overflow-tooltip="true" align="center" width="150">
            <template slot-scope={row}>{{ row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="ContractParty" label="隶属公司" :show-overflow-tooltip="true" align="center" width="150">
          </el-table-column>
          <el-table-column prop="JobName" label="岗位" :show-overflow-tooltip="true" align="center" width="150">
          </el-table-column>
          <el-table-column prop="JobClasss" label="职业类别" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="JobClasss" label="保费" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ '' }}</template>
          </el-table-column>
          <el-table-column prop="EmployeeAttribute" label="员工属性" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <el-table-column prop="Remark1" label="备注1" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark2" label="备注2" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark3" label="备注3" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CoverDay" label="在保天数" :show-overflow-tooltip="true" align="center" width="90">
          </el-table-column>
          <el-table-column prop="Status" label="人员状态" :show-overflow-tooltip="true" align="center" width="100">
          </el-table-column>
          <el-table-column prop="OperationalSource" label="来源" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="Name" label="操作" align="center" fixed="right" min-width="120px">
            <template slot-scope={row}>
              <div class="eleTabBtn">
                <el-button type="text" v-preventReClick @click="editPhone(row)">修改手机号码</el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import tabs from "./components/declareTabs.vue";
  import moment from 'moment';
  export default {
    components: {
      tabs
    },
    data() {
      return {
        name: '/underGuarantee',
        listQuery: {
          pageNum: 1,
          pageSize: 10,
          InsuranceId: '',
          InsuredCardId: '', //身份证
          InsuredName: '',
          Projectid: '', //项目
          ContractParty: '', //隶属公司
          StrMonth: '', //归属月
        },
        totalCount: 0,
        roletype: localStorage.loginRoletype,
        showDropScreen: -1,
        proNameList: [], //项目列表
        loading: false,
        tableData: [],
        userid: Cookies.get("userid-b"),
        progress: '',
        progresId: '',
        interval: null
      }
    },
    created() {
      let now = new Date();
      this.listQuery.StrMonth = moment(now).subtract(1, 'months').format('YYYY-MM')
      this.getProList();
      this.getInsuredBillPayment();
    },
    methods: {
      checkPermission,
      searchHandle() {
        this.getInsuredBillPayment();
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取缴费名单
      getInsuredBillPayment() {
        xz.getInsuredBillPayment(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.List;
            this.totalCount = res.data.Count;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error('系统出错！');
            this.tableData = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getInsuredBillPayment();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery2.pageNum = 1;
        this.listQuery2.pageSize = val;
        this.getInsuredBillPayment();
      },
      //导出列表
      expList() {
        this.loading = true;
        let data = {
          InsuredCardId: this.listQuery.InsuredCardId, //身份证
          InsuredName: '',
          Projectid: this.listQuery.Projectid, //项目
          ContractParty: this.listQuery.ContractParty, //隶属公司
          StrMonth: this.listQuery.StrMonth, //归属月
          IsExport: '1',
          pageNum: 1,
          pageSize: 10000000
        }
        xz.getInsuredBillPayment(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            aLink.download = '缴费名单.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.loading = false;
          } else {
            this.$message.error('导出失败')
            this.loading = false;
          }
        })
      },
      //确认名单
      confirmList() {
        this.progress = '';
        this.loading = true;
        xz.doMasterList(this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data != undefined && res.data) {
              this.progress = 0;
              this.progresId = res.data;
              this.interval = setInterval(this.getAsyncApplyInsuredProgress, 5000)
            } else {
              this.progress = '';
              this.$message.success('确认名单成功！');
              this.getInsuredBillPayment();
              this.loading = false;
            }
          } else {
            this.$message.error('确认名单失败！');
          }
        })
      },
      //获取审批进度
      getAsyncApplyInsuredProgress() {
        xz.getAsyncApplyInsuredProgress(this.progresId, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data.currentNum == res.data.total) {
              clearInterval(this.interval)
              this.progress = '';
              this.loading = false;
              this.$message.success(res.data.msg)
            }
            this.progress = (res.data.currentNum / res.data.total * 100).toFixed(0);
            console.log(this.progress)
          } else {
            this.loading = false;
            clearInterval(this.interval)
            this.progress = '';
            this.$message.error('获取审批进度失败')
          }
        })
      },
      getAge(idcard) {
        //获取年龄
        let myDate = new Date();
        let iden = idcard;
        let age = 0;
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;
        if (
          iden.substring(10, 12) < month ||
          (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
        ) {
          age++;
        }
        return age
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
<style>
  .page_paymentList .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_paymentList .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_paymentList .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_paymentList .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_paymentList .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  /* .page_paymentList .declareForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_paymentList .declareForm .el-form-item__error {
    top: 34px;
  } */
</style>